/*
 * The Plotex legal documents, picked by document id and language.
 *
 * Every document is published in all seven interface languages. Only some versions are authored
 * (the originals the company signed); the rest are translations of the governing original, and
 * `isTranslation` lets the page say so — a translation of a contract is not the contract.
 *
 *   terms, privacy, cookies — authored in English and Russian (scripts/generate_legal_docs.py from
 *                             docs/*.docx); English governs, the other five are translated from it.
 *   offer, agency           — the author offer and agency agreement, authored in Russian (the
 *                             Russian-law contracts creators accept); the other six are translated.
 *
 * Each version is its own chunk, loaded on demand: all of them together are several hundred KB,
 * and a reader only ever needs one.
 */
import { LANGUAGE_CODES } from '../config/region';

const AUTHORED = {
  terms:   ['en', 'ru'],
  privacy: ['en', 'ru'],
  cookies: ['en', 'ru'],
  offer:   ['ru'],
  agency:  ['ru'],
};

/* The version a translation is made from, and the one that prevails over it */
const GOVERNING = { terms: 'en', privacy: 'en', cookies: 'en', offer: 'ru', agency: 'ru' };

export const loadLegalDocument = async (id, language) => {
  if (!AUTHORED[id]) return null;
  const code = LANGUAGE_CODES[language] || GOVERNING[id];
  const module = await import(/* webpackChunkName: "legal-[request]" */ `./${id}.${code}.js`);
  return {
    ...module.default,
    isTranslation: !AUTHORED[id].includes(code),
    governingLanguage: GOVERNING[id],
  };
};

export default loadLegalDocument;
